<template>
  <nav
    class="navbar"
    :class="{ 'bg-white': false, 'navbar-transparent': !false }"
  >
    <b-modal
      v-model="showPopup"
      centered
      modal-class="app-popup-shell basket-popup-shell"
      dialog-class="app-popup-dialog basket-popup-dialog"
      content-class="app-popup-content basket-popup-content"
      body-class="app-popup-body basket-popup-body"
      :hide-footer="true"
      size="xl"
      title="" header-class="app-popup-header"
    >
      <div class="basketPopup">
        <div class="basketPopup-top">
          <div class="basketPopup-titleBlock">
            <h3 class="basketPopup-title">Mon panier devis</h3>
            <div class="basketPopup-subtitle">
              {{ basketSummary }}
            </div>
          </div>

          <div v-if="!user" class="basketPopup-actions text-right">
            <b class="basketPopup-helper">Veuillez vous connecter afin de pouvoir valider votre demande</b>
            <div class="basketPopup-actionRow">
              <b-button
                class="basketPopup-btn"
                to="/authentification"
                v-if="user === null"
              >Mon compte</b-button>
              <b-button
                class="basketPopup-btn"
                to="/inscription"
                v-if="user === null"
              >Inscription</b-button>
            </div>
          </div>
          <div v-else class="basketPopup-actions">
            <b-button
              v-if="(this.onGoingReq.length === 0) && succesMsg === false"
              class="basketPopup-btn basketPopup-btn-primary"
              @click="askDevis()"
            >Confirmer la demande de devis</b-button>
            <b-spinner
              v-if="(this.onGoingReq.length > 0) && succesMsg === false"
              variant="primary"
              label="Spinning"
            ></b-spinner>
            <div v-if="succesMsg === true" class="basketPopup-success">
              <b>Votre demande est bien envoyée</b><br>
              Vous pouvez la suivre depuis votre espace ittec
            </div>
          </div>
        </div>

        <div class="basketTableWrap" v-if="ddevis.length > 0">
          <table class="basketTable">
            <thead>
              <tr>
                <th>Produit</th>
                <th>Référence</th>
                <th>Quantité</th>
                <th class="basketTable-actionsCol">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in ddevis" :key="index">
                <td>
                  <div class="basketProductCell">
                    <img :src="getTof(item.pic)" class="basketProductThumb" />
                    <div class="basketProductInfo">
                      <div class="basketProductName">{{ item.name }}</div>
                    </div>
                  </div>
                </td>
                <td>
                  <span class="basketRef">{{ item.ref }}</span>
                </td>
                <td>
                  <div class="basketQtyCell">
                    <base-input
                      placeholder="Quantité"
                      v-model="item.qte"
                      type="num"
                      :range="{ min: 1 }"
                      :error="errorCtrl"
                    >
                    </base-input>
                  </div>
                </td>
                <td>
                  <div class="basketRowActions">
                    <button class="basketIconBtn basketIconBtn-success" @click="EditBasket()" title="Mettre à jour">
                      <b-icon icon="check-circle-fill" font-scale="1.15" aria-hidden="true"></b-icon>
                    </button>
                    <button class="basketIconBtn basketIconBtn-danger" @click="RemoveFromBasket(item.id)" title="Supprimer">
                      <b-icon icon="trash-fill" font-scale="1.15" aria-hidden="true"></b-icon>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else class="basketEmpty">
          Aucun article n'est encore ajouté à votre demande de devis.
        </div>
      </div>
    </b-modal>

    <div class="mainMenu">
      <img
        :src="require('@/assets/img/logo.gif')"
        alt=""
        class="navbar-logo"
      />

      <!-- Hamburger mobile -->
      <button class="navbar-toggler-mobile" @click="mobileMenuOpen = !mobileMenuOpen">
        <b-icon :icon="mobileMenuOpen ? 'x' : 'list'" font-scale="1.8"></b-icon>
      </button>

      <div class="navbar-actions" :class="{ 'navbar-actions-open': mobileMenuOpen }">
        <b-dropdown
          id="dropdown-right"
          right
          v-if="user"
          toggle-class="profileMenuToggle"
          menu-class="profileMenuDropdown-menu"
          no-caret
        >
          <template #button-content>
            <b-icon icon="person-lines-fill" font-scale="1.5" style="margin-right: 5px"></b-icon>
            <span class="d-none d-md-inline">{{ displayUserName }}</span>
            <b-icon icon="chevron-down" class="profileMenuCaret"></b-icon>
          </template>
          <template v-if="isBackofficeUser">
            <b-dropdown-item @click="navigateTo('products')" class="profileMenuItem profileMenuItem-light"><b-icon icon="grid-fill" class="profileMenuIcon"></b-icon> Produits et stock</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('services')" class="profileMenuItem profileMenuItem-simple"><b-icon icon="briefcase-fill" class="profileMenuIcon"></b-icon> Services & travaux</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('societes')" class="profileMenuItem profileMenuItem-simple"><b-icon icon="building" class="profileMenuIcon"></b-icon> Clients et comptes</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('ddevis')" class="profileMenuItem profileMenuItem-simple"><b-icon icon="inbox-fill" class="profileMenuIcon"></b-icon> Demandes de devis</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('devis')" class="profileMenuItem profileMenuItem-simple"><b-icon icon="journal-text" class="profileMenuIcon"></b-icon> Devis</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('cmds')" class="profileMenuItem profileMenuItem-simple"><b-icon icon="bag-fill" class="profileMenuIcon"></b-icon> Commandes</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('factures')" class="profileMenuItem profileMenuItem-simple"><b-icon icon="receipt" class="profileMenuIcon"></b-icon> Factures</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('avoirs')" class="profileMenuItem profileMenuItem-simple"><b-icon icon="arrow-counterclockwise" class="profileMenuIcon"></b-icon> Avoirs</b-dropdown-item>
            <b-dropdown-item @click="navigateToName('catalogue-admin')" class="profileMenuItem profileMenuItem-light"><b-icon icon="shop" class="profileMenuIcon"></b-icon> Catalogue admin</b-dropdown-item>
          </template>
          <template v-else>
            <b-dropdown-item v-if="user?.type !== 'GUEST'" @click="navigateTo('societes')" class="profileMenuItem profileMenuItem-light"><b-icon icon="text-left" class="profileMenuIcon"></b-icon> Mon compte</b-dropdown-item>
            <b-dropdown-item v-if="user?.type !== 'GUEST'" @click="navigateTo('ddevis')" class="profileMenuItem profileMenuItem-light"><b-icon icon="inbox-fill" class="profileMenuIcon"></b-icon> Mes demandes de devis</b-dropdown-item>
            <b-dropdown-item v-if="user?.type !== 'GUEST'" @click="navigateTo('devis')" class="profileMenuItem profileMenuItem-simple"><b-icon icon="inbox-fill" class="profileMenuIcon"></b-icon> Mes Devis</b-dropdown-item>
            <b-dropdown-item v-if="user?.type !== 'GUEST'" @click="navigateTo('cmds')" class="profileMenuItem profileMenuItem-simple"><b-icon icon="inbox-fill" class="profileMenuIcon"></b-icon> Mes Commandes</b-dropdown-item>
            <b-dropdown-item v-if="user?.type !== 'GUEST'" @click="navigateTo('factures')" class="profileMenuItem profileMenuItem-simple"><b-icon icon="inbox-fill" class="profileMenuIcon"></b-icon> Mes Factures</b-dropdown-item>
            <b-dropdown-item v-if="user?.type !== 'GUEST'" @click="navigateTo('avoirs')" class="profileMenuItem profileMenuItem-simple"><b-icon icon="inbox-fill" class="profileMenuIcon"></b-icon> Mes Avoirs</b-dropdown-item>
            <b-dropdown-item v-if="user?.type === 'GUEST'" @click="showPopup = true" class="profileMenuItem profileMenuItem-light"><b-icon icon="cart-plus-fill" class="profileMenuIcon"></b-icon> Mon panier devis</b-dropdown-item>
          </template>
          <b-dropdown-item @click="navigateTo('deconnexion')" class="profileMenuItem profileMenuItem-logout"><b-icon icon="power" class="profileMenuIcon"></b-icon> Déconnexion</b-dropdown-item>
        </b-dropdown>

        <b-button
          class="nav-action-btn nav-action-btn-icon"
          to="/inscription"
          v-if="user === null"
          title="Inscription"
          aria-label="Inscription"
          ><b-icon icon="person-plus-fill" aria-hidden="true"></b-icon></b-button
        >
        <b-button
          to="/authentification"
          class="nav-action-btn nav-action-btn-icon"
          v-if="user === null"
          title="Mon compte"
          aria-label="Mon compte"
          ><b-icon icon="person-fill" aria-hidden="true"></b-icon></b-button
        >

        <b-button
          @click="showPopup = true; succesMsg = false"
          v-if="ddevis.length > 0"
          class="nav-action-btn"
          ><b-icon icon="cart-plus-fill" aria-hidden="true"></b-icon>
          {{ ddevis.length }}</b-button
        >
        <b-button @click="navigateHome()" class="nav-action-btn"
          ><b-icon icon="house-fill" aria-hidden="true"></b-icon
        ></b-button>
      </div>
    </div>
    <div v-if="registrationSuccess" class="accountSuccessBanner">
      <div class="accountSuccessBanner-copy">
        <strong>Inscription r&eacute;ussie.</strong>
        Votre profil client est maintenant actif{{ registrationSuccessName ? ` pour ${registrationSuccessName}` : '' }}.
      </div>
      <button type="button" class="accountSuccessBanner-close" @click="registrationSuccess = false">
        Fermer
      </button>
    </div>
  </nav>
</template>
<script>
import Vue from "vue";
import { CollapseTransition } from "vue2-transitions";
import Modal from "@/components/Modal";
import { SuperAdminRouter, ClientRouter } from "@/router/initRouter";

export default {
  components: {
    CollapseTransition,
    Modal,
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    isRTL() {
      return this.$rtl.isRTL;
    },
    basketSummary() {
      const articleCount = this.ddevis.length;
      const totalQty = this.ddevis.reduce((sum, item) => sum + Number(item.qte || 0), 0);
      if (articleCount === 0) {
        return "Aucun article ajouté";
      }
      return `${articleCount} article(s) • ${totalQty} unité(s) demandée(s)`;
    },
    displayUserName() {
      if (!this.user) {
        return "";
      }
      return this.user.name || "Mon profil";
    },
    isBackofficeUser() {
      return ["ROOT", "ADMIN", "COMMERCIAL", "MAGASINIER"].includes(
        this.user?.type
      );
    },
    homeTarget() {
      return this.isBackofficeUser ? "/products" : "/catalogue";
    },
  },
  data() {
    return {
      user: null,
      ddevis: [],
      showPopup: false,
      errorCtrl: [],
      onGoingReq:[],
      succesMsg: false,
      mobileMenuOpen: false,
      registrationSuccess: false,
      registrationSuccessName: "",
      syncTimer: null,
    };
  },
  methods: {
    getTof(c) {
      return this.__.resolveMediaPath(c, "uploads/catalogue/No-Image.jpg");
    },

    EditBasket() {
      Vue.$cookies.set("devis", this.ddevis);
    },

    askDevis() {
      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.succesMsg = true;
        Vue.$cookies.remove("devis");
        this.ddevis = []
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };
      
      this.__.httpAction({
        methode: 'POST',
        route: '/dddevis/askdevis',
        data: {
          totalTTC: 0,
          totalHT: 0,
          totalTVA:0,
          devis: this.ddevis,
          owner: this.user,
          exercice: Vue.$cookies.get("exercice")
        },
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    RemoveFromBasket(id) {
      this.ddevis = this.ddevis.filter((e) => e.id !== id);
      Vue.$cookies.set("devis", this.ddevis);
    },

    ensureUserRoutes() {
      if (!this.user) {
        return;
      }

      const routes = this.$router.getRoutes();
      const hasSuperAdminRoute = routes.some((route) => route.path === "/superadmin");
      const hasClientRoute = routes.some((route) => route.path === "/client");

      if (this.isBackofficeUser && !hasSuperAdminRoute) {
        this.$router.addRoute(SuperAdminRouter);
      }

      if (this.user?.type === "CLIENT" && !hasClientRoute) {
        this.$router.addRoute(ClientRouter);
      }
    },

    navigateTo(path) {
      this.ensureUserRoutes();
      this.$router.push("/" + path);
    },
    navigateToName(name) {
      this.ensureUserRoutes();
      this.$router.push({ name });
    },
    navigateHome() {
      this.ensureUserRoutes();
      this.$router.push(this.homeTarget);
    },
    syncSessionState() {
      this.user = Vue.$cookies.get("user");
      if (this.showPopup === false) {
        this.ddevis = Vue.$cookies.get("devis") || [];
      }

      const registrationSuccess = Vue.$cookies.get("registrationSuccess");
      if (registrationSuccess) {
        this.registrationSuccessName = registrationSuccess;
        this.registrationSuccess = true;
        Vue.$cookies.remove("registrationSuccess");
      }
    },
  },
  mounted() {
    this.succesMsg = false
    this.syncSessionState();
    this.syncTimer = setInterval(() => {
      this.syncSessionState();
    }, 1000);
  },
  beforeDestroy() {
    if (this.syncTimer) {
      clearInterval(this.syncTimer);
    }
  },
};
</script>
<style scoped>
.accountSuccessBanner {
  width: 100%;
  max-width: 1140px;
  margin: 12px auto 0;
  padding: 12px 16px;
  border-radius: 16px;
  background: linear-gradient(135deg, #edf8f0 0%, #f5fbf6 100%);
  border: 1px solid #cfead7;
  box-shadow: 0 16px 32px rgba(31, 122, 69, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.accountSuccessBanner-copy {
  color: #1f5e38;
  font-size: 14px;
  line-height: 1.5;
}

.accountSuccessBanner-close {
  border: 0;
  padding: 8px 12px;
  border-radius: 10px;
  background: #1e2a44;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}

:deep(.basket-popup-shell .modal-dialog) {
  max-width: 1040px !important;
  margin-top: 2.5rem;
}

:deep(.basket-popup-content) {
  border-radius: 28px !important;
  background: linear-gradient(180deg, #f4f7fb 0%, #edf2f7 100%) !important;
  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.24) !important;
}

:deep(.basket-popup-body) {
  padding: 14px 18px 20px !important;
}

.basketPopup {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.basketPopup-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 18px;
  padding: 10px 10px 0;
}

.basketPopup-title {
  margin: 0 0 6px;
  color: #1e2a44;
  font-size: 24px;
}

.basketPopup-subtitle {
  color: #5f6f8b;
  font-size: 14px;
}

.basketPopup-actions {
  max-width: 380px;
}

.basketPopup-helper {
  display: block;
  color: #4b587c;
  margin-bottom: 10px;
}

.basketPopup-actionRow {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.basketPopup-btn {
  border-radius: 12px;
  padding: 10px 18px;
  font-weight: 600;
}

.basketPopup-btn-primary {
  background: #1e2a44;
  border-color: #1e2a44;
}

.basketPopup-success {
  color: #1f7a45;
  background: #eef9f1;
  border: 1px solid #cfead7;
  padding: 12px 14px;
  border-radius: 14px;
}

.basketTableWrap {
  overflow-x: auto;
  border: 1px solid #dfe5ec;
  border-radius: 22px;
  background: #fff;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7), 0 10px 24px rgba(15, 23, 42, 0.06);
}

.basketTable {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.basketTable thead th {
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f6 100%);
  color: #4b587c;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 14px 16px;
  border-bottom: 1px solid #dfe5ec;
}

.basketTable tbody td {
  padding: 16px;
  border-bottom: 1px solid #eef2f6;
  vertical-align: middle;
  background: rgba(255, 255, 255, 0.9);
}

.basketTable tbody tr:last-child td {
  border-bottom: 0;
}

.basketProductCell {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 260px;
}

.basketProductThumb {
  width: 72px;
  height: 72px;
  object-fit: contain;
  border-radius: 14px;
  background: #f8fafc;
  border: 1px solid #e8edf3;
  padding: 6px;
}

.basketProductName {
  color: #1e2a44;
  font-weight: 700;
  line-height: 1.35;
}

.basketRef {
  color: #5f6f8b;
  font-size: 13px;
  font-weight: 600;
}

.basketQtyCell {
  width: 120px;
}

.basketRowActions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.basketTable-actionsCol {
  width: 120px;
  text-align: right;
}

.basketIconBtn {
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  box-shadow: 0 8px 18px rgba(30, 42, 68, 0.16);
}

.basketIconBtn-success {
  background: #1f9d57;
}

.basketIconBtn-danger {
  background: #dc3545;
}

.basketEmpty {
  padding: 26px;
  text-align: center;
  color: #5f6f8b;
  background: #fff;
  border: 1px dashed #d7dfe8;
  border-radius: 18px;
}

.dropdown-toggle {
  margin-top: 0px !important;
  padding: 9px 16px !important;
  background: rgba(15, 23, 42, 0.18) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255,255,255,0.18) !important;
  transition: background 0.2s, transform 0.2s;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.14);
}
.dropdown-toggle:hover {
  background: rgba(15, 23, 42, 0.28) !important;
  transform: translateY(-1px);
}

.profileMenuCaret {
  margin-left: 10px;
  font-size: 12px;
}

:deep(.dropdown-menu) {
  margin-top: 12px;
  border: 1px solid #dbe4f0;
  border-radius: 18px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 24px 54px rgba(15, 23, 42, 0.16);
}

:deep(.dropdown-item) {
  border-radius: 12px;
  padding: 10px 12px;
  color: #1e2a44;
  font-weight: 600;
}

:deep(.dropdown-item:hover) {
  background: #eef4fb;
  color: #1e2a44;
}

.simple {
  background: #f2f2f2;
  border-bottom: solid 1px #ccc;
}
.light {
  background: #fff;
  border-bottom: solid 1px #ccc;
}
.logout {
  background: #f1851b;
  color: white;
}
.admin {
  background: #f1aeae;
  color: white;
}

:deep(.profileMenuDropdown-menu) {
  min-width: 270px;
  margin-top: 14px !important;
  padding: 8px !important;
  border-radius: 18px !important;
  overflow: hidden;
}

:deep(.profileMenuDropdown-menu .dropdown-item) {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
  margin-bottom: 4px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  white-space: normal;
}

:deep(.profileMenuDropdown-menu .dropdown-item:last-child) {
  margin-bottom: 0;
}

.profileMenuIcon {
  margin-right: 2px;
  flex: 0 0 auto;
}

.profileMenuItem-light {
  background: #ffffff;
  border: 1px solid #edf2f7;
}

.profileMenuItem-simple {
  background: #f8fafc;
  border: 1px solid #edf2f7;
}

.profileMenuItem-logout {
  background: linear-gradient(135deg, #f59d2a 0%, #f1851b 100%);
  color: #fff !important;
  border: 0;
}

:deep(.profileMenuDropdown-menu .dropdown-item.profileMenuItem-logout:hover) {
  background: linear-gradient(135deg, #f7aa45 0%, #f28f2b 100%) !important;
  color: #fff !important;
}

.navbar-logo {
  height: 90px;
  flex-shrink: 0;
}

.mainMenu {
  width: 100%;
  max-width: 1140px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 0 8px;
}

.navbar-toggler-mobile {
  display: none;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: background 0.2s;
}
.navbar-toggler-mobile:hover {
  background: rgba(255,255,255,0.1);
}

.navbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-action-btn {
  min-width: 42px;
  padding: 9px 14px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 12px;
  transition: all 0.2s;
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.14);
  min-height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.nav-action-btn-icon {
  width: 42px;
  padding: 0;
}

.nav-action-btn:hover {
  transform: translateY(-1px);
}

.nav-action-btn .b-icon {
  font-size: 15px;
}

@media (max-width: 768px) {
  :deep(.basket-popup-shell .modal-dialog) {
    max-width: calc(100vw - 18px) !important;
    margin-top: 90px !important;
  }

  :deep(.basket-popup-body) {
    padding: 10px 10px 14px !important;
  }

  .basketPopup-top {
    flex-direction: column;
  }

  .basketPopup-actions {
    max-width: none;
    width: 100%;
  }

  .basketPopup-actionRow {
    justify-content: stretch;
  }

  .basketPopup-btn {
    width: 100%;
  }

  .basketProductCell {
    min-width: 220px;
  }

  .basketTable thead th,
  .basketTable tbody td {
    padding: 12px;
  }

  .basketTable-actionsCol,
  .basketRowActions {
    text-align: left;
    justify-content: flex-start;
  }

  .navbar-logo {
    height: 36px;
  }
  .navbar-toggler-mobile {
    display: block;
  }
  .navbar-actions {
    display: none;
    flex-direction: column;
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    background: #1e1e2f;
    padding: 12px 15px;
    z-index: 1060;
    align-items: stretch;
    gap: 6px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  }
  .navbar-actions-open {
    display: flex;
  }
  .nav-action-btn {
    width: 100%;
    min-width: 0;
    margin: 0;
    text-align: center;
  }
  .accountSuccessBanner {
    margin: 8px 10px 0;
    padding: 12px;
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>

